Namespace('Customer.Views.Reports')

class Customer.Views.Reports.TeamSelectorView extends Backbone.View
  template: JST["backbone/templates/customer/reports/customer_reports/team_selector"]
  className: 'form-group teams-form'

  initialize: (options) ->
    @hasGeneralActivityTeam = options.hasGeneralActivityTeam
    @teams = options.teams

  render: =>
    @$el.html(@template(
        hasGeneralActivity: @hasGeneralActivityTeam,
        teams: @teams,
      )
    )
    @delegateEvents()
    @

  setHasGeneralActivity: (state) =>
    @hasGeneralActivityTeam = state
    @render()
